export default __webpack_public_path__ + "img/trending_bottom3.a709c650.jpg";